
document.addEventListener('submit', async e => {
  const form = e.target.closest('[data-ajax-cart-form]');
  if (!form) return;

  e.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const originalText = button ? button.textContent : '';
  const quickShop = document.getElementById('rik-quick-shop-drawer');
  const isQuickShop = Boolean(
    quickShop && quickShop.contains(form)
  );

  if (form.dataset.rikSubmitting === 'true') return;
  form.dataset.rikSubmitting = 'true';

  if (button) {
    button.disabled = true;
    button.textContent = 'ADDING…';
  }

  let added = false;

  try {
    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + 'cart/add.js',
      {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description || result.message ||
        'Unable to add this selection'
      );
    }

    added = true;

    // Refresh cart count without relying on theme helper functions.
    try {
      const cartResponse = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart.js'
      );

      if (cartResponse.ok) {
        const cart = await cartResponse.json();

        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart }
          })
        );
      }
    } catch (refreshError) {
      console.warn(
        'Item added, but cart count could not refresh:',
        refreshError
      );
    }

    // Notify Quick Shop that the item was successfully added.
    if (isQuickShop) {
      form.dispatchEvent(
        new CustomEvent('cart:added', {
          bubbles: true,
          detail: { item: result }
        })
      );
    }

    // Open existing theme cart drawer if available.
    const cartDrawer = document.querySelector('[data-cart-drawer]');

    if (cartDrawer && typeof openCart === 'function') {
      openCart();
    } else {
      // Keep the customer on the current page.
      // They can access the cart through the header.
      console.info('Item added to cart successfully.');
    }

  } catch (error) {
    console.error('Risk is Key cart error:', error);

    if (!added && button) {
      button.textContent = 'TRY AGAIN';
    }

  } finally {
    delete form.dataset.rikSubmitting;

    if (button) {
      button.disabled = false;

      if (added) {
        button.textContent = originalText;
      }
    }
  }
});

/*
 * RISK IS KEY — VIEW CART NAVIGATION
 * Works with cart drawer links and buttons.
 */

document.addEventListener('click', function(event) {
  const cartDrawer = event.target.closest('[data-cart-drawer]');

  if (!cartDrawer) return;

  const viewCart = event.target.closest(
    '[data-view-cart], ' +
    '[data-cart-view], ' +
    '.cart-drawer__view-cart, ' +
    'a[href="/cart"], ' +
    'a[href$="/cart"]'
  );

  if (!viewCart) return;

  event.preventDefault();

  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = root.endsWith('/')
    ? root + 'cart'
    : root + '/cart';

  window.location.assign(cartUrl);
});

/*
 * RISK IS KEY — CART DRAWER REPAIR
 * Restores shopping bag opening and closing.
 * Preserves existing AJAX Add to Bag.
 */

window.openCart = function () {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');

  if (!drawer) {
    window.location.assign('/cart');
    return;
  }

  drawer.classList.add('is-open');

  if (overlay) {
    overlay.classList.add('is-open');
  }

  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-open');

  const closeButton = drawer.querySelector('[data-cart-close]');

  if (closeButton) {
    closeButton.focus();
  }
};

window.closeCart = function () {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');

  if (drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (overlay) {
    overlay.classList.remove('is-open');
  }

  document.body.classList.remove('drawer-open');
};

// Handle shopping bag, close button, and overlay.
document.addEventListener('click', function (event) {

  const viewCart = event.target.closest('[data-view-cart]');

  if (viewCart) {
    event.preventDefault();
    window.location.assign('/cart');
    return;
  }

  const cartOpen = event.target.closest('[data-cart-open]');

  if (cartOpen) {
    event.preventDefault();
    window.openCart();
    return;
  }

  const cartClose = event.target.closest('[data-cart-close]');

  if (cartClose) {
    event.preventDefault();
    window.closeCart();
    return;
  }

  if (event.target.matches('[data-cart-overlay]')) {
    window.closeCart();
  }
});

// Escape key closes cart drawer.
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    const drawer = document.querySelector('[data-cart-drawer]');

    if (drawer && drawer.classList.contains('is-open')) {
      window.closeCart();
    }
  }
});

/* ============================================
   RISK IS KEY — LIVE CART DRAWER REFRESH
   Updates drawer after AJAX Add to Bag
   ============================================ */

(function () {
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = root + 'cart.js';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: currency || 'USD'
        }
      ).format(cents / 100);
    } catch (_) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function createElement(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }

  async function refreshCartDrawer() {
    const container = document.querySelector(
      '[data-cart-drawer-content]'
    );

    if (!container) return;

    const response = await fetch(endpoint, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Could not refresh cart');
    }

    const cart = await response.json();

    document.querySelectorAll('[data-cart-count]')
      .forEach(el => {
        el.textContent = cart.item_count;
      });

    const fragment = document.createDocumentFragment();

    if (!cart.item_count) {
      const empty = createElement('div', 'drawer-empty');
      empty.appendChild(
        createElement('p', '', 'Your bag is empty.')
      );

      const shop = createElement(
        'a', 'btn', 'SHOP THE DROP'
      );
      shop.href = root + 'collections/all';
      empty.appendChild(shop);
      fragment.appendChild(empty);
    } else {

      // Free shipping messaging for eligible US orders
      const currency = cart.currency || 'USD';

      if (currency === 'USD') {
        const threshold = 7500;
        const remaining = Math.max(
          0, threshold - cart.total_price
        );

        const progress = createElement(
          'div', 'shipping-progress'
        );

        const copy = createElement(
          'div', 'shipping-progress__copy'
        );
        copy.setAttribute('data-shipping-copy', '');

        copy.textContent = remaining > 0
          ? "YOU'RE " + money(remaining, currency) +
            " FROM FREE STANDARD SHIPPING ON ELIGIBLE U.S. ORDERS"
          : 'U.S. FREE STANDARD SHIPPING THRESHOLD REACHED ✓';

        const track = createElement(
          'div', 'shipping-progress__track'
        );

        const fill = document.createElement('span');
        fill.style.width = Math.min(
          100,
          (cart.total_price / threshold) * 100
        ) + '%';

        track.appendChild(fill);
        progress.append(copy, track);
        fragment.appendChild(progress);
      }

      cart.items.forEach(item => {
        const row = createElement('div', 'drawer-item');

        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.product_title || '';
          img.loading = 'lazy';
          img.className = 'drawer-item__image';
          row.appendChild(img);
        }

        const details = document.createElement('div');

        const link = createElement(
          'a', '', item.product_title
        );
        link.href = item.url;
        const strong = createElement(
          'strong', '', item.product_title
        );
        link.textContent = '';
        link.appendChild(strong);
        details.appendChild(link);

        if (
          item.variant_title &&
          item.variant_title !== 'Default Title'
        ) {
          details.appendChild(
            createElement(
              'small', '', item.variant_title
            )
          );
        }

        details.appendChild(
          createElement(
            'span', '',
            'Qty: ' + item.quantity +
            ' · ' + money(item.final_line_price, currency)
          )
        );

        const remove = createElement(
          'a', 'drawer-remove', 'Remove'
        );
        remove.href = root + 'cart/change?line=' +
          (cart.items.indexOf(item) + 1) +
          '&quantity=0';

        details.appendChild(remove);
        row.appendChild(details);
        fragment.appendChild(row);
      });

      const total = createElement(
        'div', 'drawer-total'
      );
      total.appendChild(
        createElement('span', '', 'Subtotal')
      );
      total.appendChild(
        createElement(
          'strong', '',
          money(cart.total_price, currency)
        )
      );
      fragment.appendChild(total);

      const checkout = createElement(
        'a', 'btn drawer-checkout',
        'VIEW BAG & CHECKOUT'
      );
      checkout.href = root + 'cart';
      checkout.setAttribute('data-view-cart', '');
      fragment.appendChild(checkout);

      fragment.appendChild(
        createElement(
          'small', 'drawer-note',
          'Taxes and shipping calculated at checkout.'
        )
      );
    }

    container.replaceChildren(fragment);
  }

  // Refresh whenever the existing AJAX cart code
  // reports an updated cart.
  document.addEventListener('cart:updated', () => {
    refreshCartDrawer().catch(console.error);
  });

  // Also refresh when the shopping bag opens.
  document.addEventListener('click', event => {
    if (event.target.closest('[data-cart-open]')) {
      refreshCartDrawer().catch(console.error);
    }
  });

  // Make available for future cart interactions.
  window.refreshCartDrawer = refreshCartDrawer;
})();
